var TEMPLATE_URL = require('./preferences.html');
var angular = require('angular');
angular.module('ikeweb.user').controller('PreferencesController', ['$scope', 'unitService', 'pubSubService', 'userTopics',

    function($scope, unitService, pubSubService, userTopics) {

        function success() {
            $scope.loading = false;
            pubSubService.publish(userTopics.PREFERENCES.UPDATED);
            $scope.$broadcast($scope.dismissEvent);
        }

        function error() {
            $scope.loading = false;
        }

        $scope.update = function() {
            if ($scope.formHolder.userPreferencesForm.$valid) {
                $scope.loading = true;
                unitService.setUnit($scope.formData.unit).then(success, error);
            }
        };
    }
]);

angular.module('ikeweb.user').directive('userPreferences', ['unitService',
    function(unitService) {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                displayEvent: '@',
                dismissEvent: '@'
            },
            link: function($scope, $element) {

                $scope.formHolder = {};
                $scope.formData = {};
                $scope.notifications = {};
                $scope.loading = false;
                $scope.units = unitService.getUnitList();

                function setUserUnit() {
                    $scope.units = unitService.getUnitList();
                    $scope.formData.unit = unitService.getUnit();
                }
                $scope.formData.unit = unitService.getUnit();

                $scope.$on($scope.displayEvent, setUserUnit);

                $scope.submit = function() {
                    setTimeout(function() {
                        $element.find('.UserPreferences-formSubmit').click();
                    });
                };

            },
            controller: 'PreferencesController'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/preferences/preferences.directive.js
// module id = 475
// module chunks = 0